import Pagination from "react-js-pagination";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { open, close } from "../redux/popupSlice";
import routes from '../libs/routes';
import * as API from "../libs/service";
import PopupUpdateEdu from "../pages/popup/PopupUpdateEdu";
import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import moment from "moment";

export default function PaginationEdu(props) {
  const { coupon, setSelectedItems, modifyLicense, chkReset } = props;
  const dispatch = useDispatch();
  const { mbData } = useSelector((s) => s.usersReducer);
  const lang = useSelector(state => state.langReducer.lang);

  // coupon(필터링된 eduData)를 그대로 사용
  const dataList = coupon;
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const itemsPerPage = 8;
  const indexOfLastItem = page * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);

  const LicensePop = async (mb_email) => {
    dispatch(loadingStart());
    const res = await API.get(`etc/partner/${mb_email}/${mbData?.emailLanguage || 'en'}`);
    if (res?.data?.msg === 'success') {
      dispatch(open({
        component: (
          <PopupUpdateEdu
            max_width={'500px'}
            x_btn={true}
            updateEdu={true}
            updateEduEmail={mb_email}
            button={lang === 0 ? '인증번호 요청' : 'Request Verification Code'}
            buttonCancel={lang === 0 ? '취소' : 'Cancel'}
          />
        )
      }));
    }
    dispatch(loadingEnd());
  };

  const getStatus = (x) => {
    if (!x) return { status: '', preStatus: false };
    const today = new Date();
    const expired = new Date(x.revokedAt || x.licenseGroup.expiredAt);
    let status;
    let preStatus = false;
    if (expired < today) {
      status = lang === 0 ? '만료' : 'Expired';
    } else if (expired - today < 1000 * 60 * 60 * 24 * 30) {
      status = lang === 0 ? '만료' : 'Expired';
      preStatus = true;
    } else {
      status = lang === 0 ? '활성' : 'Active';
    }

    return { status, preStatus };
  };

  const getLine = (x) => {
    const { status, preStatus } = getStatus(x);
    return (
      <div key={x.id} className={`my_coupon_info`}>
        <p className="top25p">{x.licenseCode}</p>
        <p className="top25p">{moment(x.createdAt).format('YYYY-MM-DD HH:mm')}</p>
        <p className="top25p">
          {x.revokedAt || (x.licenseGroup && x.licenseGroup.expiredAt)
            ? moment(x.revokedAt || x.licenseGroup.expiredAt).format('YYYY-MM-DD HH:mm')
            : '-'}
        </p>
        <p className="top25p">
          {status === (lang === 0 ? '활성' : 'Active') ? (
            <>
              <img src={require("../assets/icon/solid_check.svg").default} style={{ marginRight: '4px' }} />
              {lang === 0 ? '활성' : 'Active'}
            </>
          ) : (
            <>
              {lang === 0 ? `만료${preStatus ? ' 예정' : ''}` : preStatus ? 'Expiring Soon' : 'Expired'}
            </>
          )}
        </p>
        {status === (lang === 0 ? '만료' : 'Expired') && (
          <p className="info">
            <button type="button" onClick={() => LicensePop(mbData?.mb_email)}>
              {lang === 0 ? '갱신하기' : 'Renew'}
            </button>
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="PaginationContent">
      <div className={`my_coupon_list_box page_edu`}>
        <div className="list_title">
          <p className="top25p">{lang === 0 ? '라이선스 no' : 'License No.'}</p>
          <p className="top25p">{lang === 0 ? '시작일' : 'Start Date'}</p>
          <p className="top25p">{lang === 0 ? '사용기한' : 'Expiration Date'}</p>
          <p className="top25p">{lang === 0 ? '라이선스 상태' : 'License Status'}</p>
          {
            getStatus(dataList[0]).status === (lang === 0 ? '만료' : 'Expired') && (
                <p className="info">{''}</p>
            )
          }
        </div>
        {dataList && dataList.length > 0 ? (
          <>
            {Items.map(x => getLine(x))}
          </>
        ) : (
          <p className="not_coupon">
            {lang === 0 ? '결제 내역이 없습니다.' : 'No payment history.'}
          </p>
        )}
      </div>
      <Pagination
        className="my-pagination"
        activePage={page}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={dataList.length || 1}
        pageRangeDisplayed={10}
        onChange={handlePageChange}
        nextPageText={<img src={require("../assets/icon/page_right.svg").default} />}
        prevPageText={<img src={require("../assets/icon/page_left.svg").default} />}
        firstPageText={<img src={require("../assets/icon/page_left_set.svg").default} />}
        lastPageText={<img src={require("../assets/icon/page_right_set.svg").default} />}
      />
    </div>
  );
}